const routes = {
  myGear: '/mygear',
};

export default routes;
